import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { AppContext } from "../../../context/AppContext";
import { toastError, toastWarn } from "../../../common/Toast";
import "tabulator-tables/dist/css/tabulator.min.css";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const Undepositedbalancesummery = (props) => {
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const { CurrencySymbol, FractionDigits, currencySymbolLocation } =
    useContext(AppContext);

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  const columns = [
    {
      title: "Payment Type",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "Paymenttypename",
      frozen: true,
      defaultVisible: true,
      bottomCalc: "sum",
    },
    {
      title: "( 0- 3 days)",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "threepayamt",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        const numericValue =
          value == "0.00" || value === "" || value == null
            ? "0.0"
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        return `<span style="
                color: #333;
                font-weight: bold;
                text-decoration: underline;
                cursor: pointer;
              ">${numericValue}</span>`;
      },
    },
    {
      title: "(4-7 days)",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "sevenpayamt",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        const numericValue =
          value == "0.00" || value === "" || value == null
            ? "0.0"
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        return `<span style="
          color: #333;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        ">${numericValue}</span>`;
      },
    },
    {
      title: "( 8- 10 days)",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "tenpayamt",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        const numericValue =
          value == "0.00" || value === "" || value == null
            ? "0.0"
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        return `<span style="
          color: #333;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        ">${numericValue}</span>`;
      },
    },
    {
      title: "0 - upcoming Days",
      headerMenu: headerMenu,
      headerFilter: "input",
      field: "PaymentAmount",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        const numericValue =
          value == "0.00" || value === "" || value == null
            ? "$ 0.0"
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        return `<span style="
          color: #333;
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        ">${numericValue}</span>`;
      },
    },
  ];



  function getFormattedDateTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(now.getDate()).padStart(2, '0');

  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

console.log(getFormattedDateTime());



  const apiCall = () => {
    setLoading(true);
    setResponseData([]);

    axios
      .get(`${config.reportsBaseUrl}/reports/undepositedbalancesummery?CurrentDate=${getFormattedDateTime()}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData?.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went Wrong");
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
    apiCall();
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Undeposited Summary Report
                </li>
              </ul>
            </div>
          </div>

          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Sales Velocity Report</p>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div>
                      <CommonTabular
                        Data={responseData}
                        columns={columns}
                        Groupvalue={[]}
                        Reportname={"Sales Velocity Report"}
                        frozenRowvalue={0}
                        height={"auto"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Undepositedbalancesummery;
